/*
  Releases the third-party scripts deferred in snippets/social-meta-tags.liquid.

  Rewritten 2026-09-01. The previous version released only on user interaction,
  and its script-swap threw a TypeError (it called parentNode.insertBefore on a
  node it had already removed), so anything it deferred could be stranded.

  Now: releases on the first interaction, or 2.5s after load, whichever comes
  first, so scripts still run for visitors who never touch the page.
*/
(function () {
  var released = false;

  function release() {
    if (released) return;
    released = true;

    if (window.humrahaDeferObserver) {
      window.humrahaDeferObserver.disconnect();
    }

    document.querySelectorAll('iframe.lazy[data-src]').forEach(function (frame) {
      frame.src = frame.dataset.src;
    });

    document.querySelectorAll('script[data-src]').forEach(function (script) {
      script.setAttribute('src', script.getAttribute('data-src'));
      script.removeAttribute('data-src');
    });

    document.querySelectorAll('script[type="text/lazyload"]').forEach(function (script) {
      var replacement = document.createElement('script');
      for (var i = 0; i < script.attributes.length; i++) {
        var attribute = script.attributes[i];
        replacement.setAttribute(attribute.name, attribute.value);
      }
      replacement.type = 'text/javascript';
      replacement.innerHTML = script.innerHTML;
      script.parentNode.insertBefore(replacement, script);
      script.parentNode.removeChild(script);
    });

    document.querySelectorAll('link[data-href]').forEach(function (link) {
      link.setAttribute('href', link.getAttribute('data-href'));
      link.removeAttribute('data-href');
    });

    document.dispatchEvent(new CustomEvent('asyncLazyLoad'));
  }

  var events = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click', 'keypress', 'touchmove'];
  events.forEach(function (name) {
    window.addEventListener(name, release, { once: true, passive: true });
  });

  function startFallback() {
    setTimeout(release, 2500);
  }

  if (document.readyState === 'complete') {
    startFallback();
  } else {
    window.addEventListener('load', startFallback, { once: true });
  }
})();